import { createQuery } from '@tanstack/svelte-query';
import { fetchRCUs } from '$lib/api/rcu';
import type { RCUResponse } from '$lib/types/rcu';
import { resolveScope, getUnitScope, type ScopeFn } from './scope';

export const rcusQuery = (scope: ScopeFn = getUnitScope()) =>
	createQuery<Array<RCUResponse>>(() => {
		const unitId = resolveScope(scope);
		return {
			queryKey: ['rcus', { unitId }],
			queryFn: async () => {
				const all = await fetchRCUs();
				return all.filter((r) => r.unit === unitId);
			},
			enabled: unitId > 0
		};
	});
